<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @checkboxChange="(e) => (checkData = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :badgeNumber="checkCount"
        @query="getData"
        @reset="resetPage({ pageSize: 100 })"
        @batchChoose="batchChoose"
        @exportExcel="exportExcel"
        @confirmShipment="confirmShipment"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ConfirmShipment
      :visible.sync="confirmShipmentVisible"
      title="确认发运信息"
      :data.sync="checkData"
      @reload="reload"
      @delete="onConfirmShipmentDelete"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import ConfirmShipment from '../confirm-shipment'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  components: { PageMain, PageHeader, ConfirmShipment },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      listCode: [],
      confirmShipmentVisible: false,
      checkData: [],
    }
  },
  computed: {
    checkCount() {
      if (!this.checkData) return 0
      return this.checkData.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .orderBatchShipmentPlanListApi({
          ...form,
          listCode: this.listCode,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.listCode = []
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchChoose() {
      const data = this.$refs.main.getCheckboxRecords()
      if (data) {
        const listCode = data.map((row) => {
          return row.orderBatchCode
        })
        if (listCode) {
          this.listCode = listCode
          this.$refs.header.query()
        }
      }
    },
    confirmShipment() {
      if (!this.checkData || !this.checkData.length) {
        this.$message({
          showClose: true,
          message: '请选择需要发运的批次',
          type: 'warning',
        })
        return
      }
      this.confirmShipmentVisible = true
    },
    exportExcel() {
      this.$refs.main.exportExcel()
    },
    onConfirmShipmentDelete(e) {
      if (!e || !e.length) return

      this.checkData = this.checkData.filter((i) => {
        return e.findIndex((j) => i.orderBatchCode === j.orderBatchCode) < 0
      })

      this.$refs.main.clearCheckboxRows(e)
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
